/**
 * Copyright © 2024 Delicious AI, LLC
 */

import { parsePhoneNumberFromString } from 'libphonenumber-js'

const PHONE_NUMBER_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/

const isValidPhoneOrEmpty = (value: string | null | undefined): boolean => {
  if (value === null || value === undefined || value === '') {
    return true
  }
  return PHONE_NUMBER_REGEX.test(value)
}

const formatPhoneNumber = (value: string) => {
  if (!value) return value

  const phoneNumber = parsePhoneNumberFromString(value)

  if (phoneNumber) return phoneNumber.formatNational()

  // Remove all non-numeric characters except parentheses and dashes
  const digits = value.replace(/[^\d]/g, '')

  const hasOpenParen = value.includes('(')
  const hasCloseParen = value.includes(')')
  const hasDash = value.includes('-')
  const hasSpace = value.includes(' ')

  if (!digits.length) return hasOpenParen ? '(' : ''
  if (digits.length < 4)
    return `(${digits.slice(0, 3)}${hasCloseParen ? ')' : ''}${
      hasSpace ? ' ' : ''
    }`
  if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}${hasDash ? '-' : ''}`
  }

  const formatted = `(${digits.slice(0, 3)}) ${digits.slice(
    3,
    6,
  )}-${digits.slice(6, 10)}`

  return formatted
}

const unformatPhoneNumber = (value: string) => {
  return value.replace(/[^\d]/g, '')
}

export const PhoneNumberHelpers = {
  formatPhoneNumber,
  unformatPhoneNumber,
  isValidPhoneOrEmpty,
  PHONE_NUMBER_REGEX,
}
